export const VALID_SPREADSHEET_FILES_EXTENSIONS = ["csv", "xls", "xlsx"];

export const isSpreadsheetFile = <T extends { url?: string; name?: string }>(file: T): boolean => {
  return VALID_SPREADSHEET_FILES_EXTENSIONS.some(
    (ext) =>
      file.url?.toLowerCase().endsWith(`.${ext}`) ||
      (!!file.name && file.name.toLowerCase().endsWith(`.${ext}`)),
  );
};
